import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Card, CardContent, Typography, Stack, Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import useBootstrapSize from '../../hooks/useBootstrapSize';
import ShowContainer from '../material-ui/ShowContainer';

const DashboardCard = ({
  title,
  subtitle,
  children,
  action,
  footer,
  cardheading,
  headtitle,
  headsubtitle,
  paddingDesk = 3,
  middlecontent
}) => {
  const customizer = useSelector((state) => state.customizer);
  const { t } = useTranslation();
  const { isMobile } = useBootstrapSize();

  const theme = useTheme();
  const borderColor = theme.palette.grey[100];

  const ContainerTitle = (text) => (typeof title == 'string' ? t(text) : text);

  return (
    <Card
      sx={{ padding: 0, border: !customizer.isCardShadow ? `1px solid ${borderColor}` : 'none' }}
      elevation={customizer.isCardShadow ? 9 : 0}
      variant={!customizer.isCardShadow ? 'outlined' : undefined}>
      {cardheading ? (
        <CardContent>
          <Typography variant="h6">{ContainerTitle(headtitle)}</Typography>
          <Typography variant="subtitle2" color="textSecondary">
            {ContainerTitle(headsubtitle)}
          </Typography>
        </CardContent>
      ) : (
        <CardContent sx={{ p: isMobile ? 1 : paddingDesk }}>
          {title ? (
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems={'center'}
              mb={1}>
              <Box>
                {title ? <Typography variant="h5">{ContainerTitle(title)}</Typography> : ''}

                <ShowContainer condition={subtitle}>
                  {typeof subtitle === 'string' ? (
                    <Typography variant="subtitle2" color="textSecondary">
                      {ContainerTitle(subtitle)}
                    </Typography>
                  ) : (
                    subtitle
                  )}
                </ShowContainer>
              </Box>
              {action}
            </Stack>
          ) : null}

          {children}
        </CardContent>
      )}

      {middlecontent}
      {footer}
    </Card>
  );
};

export default DashboardCard;
